import { cn } from '../../utils'

export const AccentHighlight = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn('absolute bottom-0 left-0 h-[1px] w-full opacity-70', className)}
      style={{
        background:
          'linear-gradient(to right, transparent 0%, transparent 15%, rgba(176, 200, 223, 0.8) 50%, transparent 85%, transparent 100%)',
      }}
    />
  )
}
